/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BigQueryNativePitrDestination } from '../models/BigQueryNativePitrDestination';

export class RestoreBigQueryNativePitrRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': BigQueryNativePitrDestination;
  /**
  * Point-in-time to restore to (ISO 8601 format). Must be within the dataset\'s time travel window (up to 7 days). Defaults to now if not specified. 
  */
  'restoreToTime'?: Date;
  /**
  * List of table names to restore. If empty or not specified, all tables in the dataset will be restored. 
  */
  'selectedTables'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "BigQueryNativePitrDestination",
      "format": ""
    },
    {
      "name": "restoreToTime",
      "baseName": "restoreToTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "selectedTables",
      "baseName": "selectedTables",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreBigQueryNativePitrRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

